module.exports = __webpack_public_path__ + "static/media/topView_icon.b8348adf.svg";